module.exports = __webpack_public_path__ + "static/media/reemmend_header.9948f9cd.png";